import { configureStore } from '@reduxjs/toolkit';
import sectionReducer from '../features/sections/sectionSlice';
import studentsReducer from '../features/students/studentsSlice'; 

export default configureStore({
  reducer: {
    sections: sectionReducer,
    students: studentsReducer
  },
});
